define(function (require) {
    var $ = require("jquery");
    var emailRegex = /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/;
    var passwordRegex = /^(?=.+?[A-Za-z])(?=.+?[0-9])(?=.+?[~!@#$%^&*_+=`|\()\-{}[\]:;'"<>,.?\/-])[a-zA-Z0-9~!@#$%^&*_+=`|\()\-{}[\]:;'"<>,.?\/-]{8,}$/;
    var passwordLetterRegex = /([A-Za-z])/;
    var passwordNumberRegex = /[0-9]/;
    var passwordSpecialCharacterRegex = /[~!@#$%^&*()_+\-=`\[\]{};':"\\|,.<>\/?]/g;
    var passwordValidCharsRegex = /^[a-zA-Z0-9~!@#$%^&*()_+\-=`\[\]{};':"\\|,.<>\/?]*$/;
    var passwordMinCharsRegex = /^\S{8,}$/;
    var usernameRegex = /^\S{8,}$/;
    var whiteSpaceRegex = /\s/g;
    var usZipCodeRegex = /^\d{5}(\-\d{4})?$/;
    var poboxRegex = /^pob |\b(?:p\.?\s*o\.?|post\s+office)\s+box\b/;

    return {
        passwordLetterRegex: passwordLetterRegex,
        passwordNumberRegex: passwordNumberRegex,
        passwordSpecialCharacterRegex: passwordSpecialCharacterRegex,
        passwordValidCharsRegex: passwordValidCharsRegex,
        passwordMinCharsRegex: passwordMinCharsRegex,
        onready: function (callback) {
            if (window.document.readyState === "complete") setTimeout(callback);
            else window.document.addEventListener("DOMContentLoaded", callback);
        },
        isMobile: function checkIsMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB10|PlayBook|IEMobile|Windows Phone|Opera Mini/i.test(navigator.userAgent);
        },
        formatPhoneString: function (phoneString) {
            if (phoneString === null) return null;

            var strippedPhoneString = phoneString.replace(/[^0-9]/g, "").toString();

            return strippedPhoneString.length === 10 ? "(" + strippedPhoneString.substr(0, 3) + ") " + strippedPhoneString.substr(3, 3) + "-" + strippedPhoneString.substr(6) : phoneString;
        },
        getDevicePlatform: function () {
            var platforms = {
                android: /Android/i,
                bada: /Bada/i,
                ios: /iPhone|iPad|iPod/i,
                blackberry: /BlackBerry|BB10|PlayBook/i,
                windows: /IEMobile|Windows/i,
                web: /webOS/i
            };

            if (!this.isMobile()) {
                return "desktop";
            }

            for (var key in platforms) {
                if (platforms.hasOwnProperty(key) && platforms[key].test(navigator.userAgent)) {
                    return key;
                }
            }
        },
        isValidEmail: function (emailValue) {
            return emailValue && emailRegex.test(emailValue) && !whiteSpaceRegex.test($.trim(emailValue));
        },
        isValidEmailLength: function (emailValue, emailMaxLength) {
            return emailValue && $.trim(emailValue).length <= emailMaxLength;
        },
        isValidPassword: function (passwordValue) {
            return passwordValue && passwordRegex.test(passwordValue) && !whiteSpaceRegex.test(passwordValue);
        },
        isValidPhone: function (phoneValue) {
            if (phoneValue.match(/[^0-9\-\(\)\s]/)) {
                return false;
            }

            return phoneValue.replace(/[^0-9]/g, "").length === 10;
        },
        isValidUsername: function (usernameValue) {
            return usernameValue && usernameRegex.test(usernameValue) && !whiteSpaceRegex.test($.trim(usernameValue));
        },
        // validate without trimming
        showConfirmFieldError: function (baseValue, confirmValue) {
            return baseValue && confirmValue && baseValue !== confirmValue;
        },

        getCacheBuster: function () {
            return { _: new Date().getTime() };
        },

        getRequestVerificationToken: function () {
            if (window.scan && window.scan.verificationToken) {
                return window.scan.verificationToken;
            } else {
                throw "window.scan.forgeryToken is undefined.";
            }
        },

        isValidUSZipCode: function (zipcodeValue) {
            return usZipCodeRegex.test(zipcodeValue);
        },

        isPostOfficeBox: function (address) {
            var isMatch = poboxRegex.test(address.toLowerCase());
            if (address.toLowerCase() == "pob") {
                isMatch = true;
            }
            return isMatch;
        },
        debounce: function(func, wait, immediate) {
            var timeout;
            return function() {
                var context = this, args = arguments;
                var later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        }
    };
});
